import type {SVGProps} from 'react'

type IconProps = SVGProps<SVGSVGElement> & {
	size?: number
	color?: string
}

export const Pencil = ({size = 10, width, height, color = 'currentColor', ...props}: IconProps) => {
	return (
			<svg
					width={width ?? size}
					height={height ?? size}
					viewBox="0 0 10 10"
					xmlns="http://www.w3.org/2000/svg"
					{...props}
			>
				<path
						d="M6.17553 1.66958L0.673402 7.17213C0.645695 7.19991 0.625949 7.23461 0.616223 7.27262L0.00634442 9.72048C-0.00262535 9.75681 -0.00207565 9.79484 0.00794042 9.83089C0.0179565 9.86694 0.0371004 9.8998 0.0635231 9.92629C0.104108 9.96674 0.159058 9.98948 0.216358 9.98952C0.234034 9.98952 0.251643 9.98734 0.268786 9.98303L2.71665 9.37307C2.75471 9.3635 2.78945 9.34376 2.81715 9.31597L8.31979 3.8138L6.17553 1.66958ZM9.6829 0.919315L9.07042 0.306858C8.66107 -0.102489 7.94762 -0.102083 7.53874 0.306858L6.78849 1.05712L8.93265 3.20126L9.6829 2.45102C9.88737 2.24663 10 1.97456 10 1.68522C10 1.39587 9.88737 1.12381 9.6829 0.919315Z"
						fill={color}
				/>
			</svg>
	)
}